/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import React from 'react'

import { Link } from '@/i18n/navigation'
import { accessTokenAtom } from '@/store/session'

/**
 * A link to the login page if the user is not logged in, or the dashboard if the user is logged in.
 */
const HeaderLoginLink: React.FC = () => {
  const t = useTranslations('HeaderLoginLink')
  const accessToken = useAtomValue(accessTokenAtom)

  return accessToken ? (
    <Link href={'/dashboard'}>{t('dashboardLinkText')}</Link>
  ) : (
    <Link href={'/login'}>{t('loginLinkText')}</Link>
  )
}

export { HeaderLoginLink }
